// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.forgot-password-container {
  max-width: 450px;
  /* Increased width */
  min-height: 300px;
  /* Added height */
  margin: 50px auto;
  padding: 30px;
  border-radius: 10px;
  background-color: white;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.15);
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.forgot-password-container .title {
  color: #014D4E;
  font-size: 22px;
  font-weight: bold;
}

.forgot-password-container .subtitle {
  color: #444;
  margin-bottom: 20px;
}

.forgot-password-container .email-input {
  width: 100%;
  margin-bottom: 15px;
}

.forgot-password-container .submit-button {
  width: 100%;
  background-color: #1f415b;
  border: none;
  margin-top: 10px;
}

.forgot-password-container .submit-button:hover {
  background-color: #005b60;
}


.forgot-password-container .message-container {
  margin-bottom: 20px;
}`, "",{"version":3,"sources":["webpack://./src/gitsubmodules/trackon/src/components/ForgotPassword/forgotPassword.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4CAA4C;EAC5C,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,mBAAmB;AACrB","sourcesContent":[".forgot-password-container {\n  max-width: 450px;\n  /* Increased width */\n  min-height: 300px;\n  /* Added height */\n  margin: 50px auto;\n  padding: 30px;\n  border-radius: 10px;\n  background-color: white;\n  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.15);\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.forgot-password-container .title {\n  color: #014D4E;\n  font-size: 22px;\n  font-weight: bold;\n}\n\n.forgot-password-container .subtitle {\n  color: #444;\n  margin-bottom: 20px;\n}\n\n.forgot-password-container .email-input {\n  width: 100%;\n  margin-bottom: 15px;\n}\n\n.forgot-password-container .submit-button {\n  width: 100%;\n  background-color: #1f415b;\n  border: none;\n  margin-top: 10px;\n}\n\n.forgot-password-container .submit-button:hover {\n  background-color: #005b60;\n}\n\n\n.forgot-password-container .message-container {\n  margin-bottom: 20px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
